import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoint, theme } from '../../theme';
import { BodyText, LinkText, LinkTextStyles } from '../typography';
import { getDefaultTitleIcon, titleColor } from './helpers';
import { InfoPanelProps } from './InfoPanel';

const HeaderContainer = styled.header`
  display: flex;
  align-items: center;

  && > * + * {
    margin-left: ${theme.spacings[1].rem};

    ${breakpoint('md')`
        margin-left: ${theme.spacings[2].rem};
    `};
  }
`;

const TitleIconStyles = css`
  width: 16px;
  height: 16px;

  ${breakpoint('sm')`
    width: 24px;
    height: 24px;
  `};
`;

const IconWrapper = styled.span`
  display: flex;

  svg {
    ${TitleIconStyles};
  }
`;

const ActionLinkText = styled.span`
  ${LinkTextStyles}
`;

export type InfoPanelHeaderProps = Pick<
  InfoPanelProps,
  'type' | 'title' | 'link' | 'linkLabel' | 'titleIcon' | 'onLinkClick'
>;

export const InfoPanelHeader: React.FC<InfoPanelHeaderProps> = ({
  type = 'info',
  title,
  linkLabel,
  link,
  titleIcon: Icon = getDefaultTitleIcon(type),
  onLinkClick,
}) => (
  <HeaderContainer>
    <IconWrapper>
      <Icon fill={titleColor(type)} />
    </IconWrapper>
    <BodyText size={{ xs: 'sm', sm: 'md' }} color={titleColor(type)}>
      <strong>{title}</strong>
    </BodyText>
    {linkLabel && (
      <>
        {link && (
          <LinkText href={link} size={{ xs: 'sm', sm: 'md' }}>
            {linkLabel}
          </LinkText>
        )}
        {onLinkClick && (
          <ActionLinkText
            context="secondary"
            isUnderlined={false}
            size={{ xs: 'sm', sm: 'md' }}
            onClick={onLinkClick}
          >
            {linkLabel}
          </ActionLinkText>
        )}
      </>
    )}
  </HeaderContainer>
);
